import {makeAutoObservable} from 'mobx';

class ModalProviderStore {
  private activeModal?: string;
  private onCloseCallback?: (accepted: boolean) => void;
  private openingPayload?: any;

  constructor() {
    makeAutoObservable(this);
  }

  public openModal(
    modal: string,
    onCloseCallback?: (closingPayload?: any) => void,
    openingPayload: any = undefined,
  ) {
    this.openingPayload = openingPayload;
    this.activeModal = modal;
    if (onCloseCallback) {
      this.onCloseCallback = onCloseCallback;
    }
  }

  public getActiveStore() {
    return this.activeModal;
  }

  public getOpeningPayload() {
    return this.openingPayload;
  }

  public onClose(accepted: boolean) {
    this.activeModal = undefined;
    this.openingPayload = undefined;
    if (this.onCloseCallback) {
      this.onCloseCallback(accepted);
      this.onCloseCallback = undefined;
    }
  }
}

export default ModalProviderStore;
